import React, { useState, useRef, useEffect } from "react";
import logo from "../assets/admin/logo.png"; // Make sure you have a logo.png file in the correct path
import logo1 from "../assets/images/Group 38031.png"; // Make sure you have a logo.png file in the correct path
import searchicon from "../assets/images/Group 38040.png"; // Make sure you have a logo.png file in the correct path
import icon from "../assets/admin/icon.png";
import icon1 from "../assets/admin/icon1.png";
import icon2 from "../assets/admin/icon2.png";
import icon3 from "../assets/admin/icon3.png";
import icon4 from "../assets/admin/icon4.png";
import icon5 from "../assets/admin/icon5.png";
import "./dashboard.css";
import CanvasJSReact from "@canvasjs/react-charts";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import { Circles } from "react-loader-spinner";
import BASE_URL from "../config";
import Sidebarpo from "../POpage/Sidebarpo";
import SidebarRFQ from "../POpage/SidebarRFQ";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  AreaChart,
  BarChart,
  Bar,
  PieChart,
  Pie,
  Cell,
  ReferenceLine,
  Legend,
} from "recharts";

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const TopBar = ({ activeTab, setActiveTab }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); // ✅ Loader state
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("userdata"));

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");
    setLoading(true); // ✅ Show loader

    try {
      await axios.post(
        `${BASE_URL}/api/logout`,
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      Swal.fire(
        "Logged Out",
        "You have been logged out successfully",
        "success",
      );
      localStorage.clear();
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
      Swal.fire("Error", "Failed to log out. Please try again.", "error");
    } finally {
      setLoading(false); // ✅ Hide loader
    }
  };

  return (
    <div className="row align-items-center py-1">
      <div className="col-lg-2">
        <h4>Dashboard</h4>
      </div>

      <div className="col-lg-7 d-flex gap-2 align-items-center ">
        <button
          className={` btn-sm tabbutton  ${
            activeTab === "rfq" ? "active" : ""
          }`}
          onClick={() => setActiveTab("rfq")}
        >
          RFQ
        </button>
        <button
          className={` btn-sm ml-2 tabbutton1 ${
            activeTab === "po" ? "active" : ""
          }`}
          onClick={() => setActiveTab("po")}
        >
          PO
        </button>
        {/* <input
          type="text"
          className="form-control form-control-sm w-50 serchinput ml-2"
          placeholder="    Search..."
        />
        <img src={searchicon} alt="logo" width="30" height="30" className="ml-2" /> */}

        <div className="position-relative w-100 ml-2">
          <input
            type="text"
            className="form-control form-control-sm serchinput pr-5"
            placeholder="  Search..."
          />
          <img
            src={searchicon}
            alt="search"
            width="35"
            height="35"
            className="search-icon-inside"
          />
        </div>

        <Link to="/alert">
          <img src={logo1} alt="logo" width="40" height="40" className="ml-2" />
        </Link>
      </div>

      <div
        className="col-lg-3 text-end position-relative end-text"
        ref={dropdownRef}
      >
        <h6
          onClick={() => setDropdownOpen(!dropdownOpen)}
          style={{
            cursor: "pointer",
            userSelect: "none",
            display: "inline-flex",
            alignItems: "center",
          }}
        >
          <img
            src={logo}
            alt="logo"
            width="40"
            height="40"
            className="rounded-circle"
            style={{ marginRight: "8px", objectFit: "cover" }}
          />
          <div style={{ lineHeight: "1", marginRight: "10px" }}>
            Welcome
            <br />
            <strong>{user?.name || "User"}</strong>
          </div>
          <span
            style={{
              width: "30px",
              height: "30px",
              borderRadius: "50%",
              backgroundColor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 0 3px rgba(0,0,0,0.1)",
            }}
          >
            {dropdownOpen ? "▲" : "▼"}
          </span>
        </h6>

        {dropdownOpen && (
          <div
            className="dropdown-menu show"
            style={{
              position: "absolute",
              right: 0,
              top: "100%",
              background: "white",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              borderRadius: "6px",
              minWidth: "160px",
              zIndex: 1000,
            }}
          >
            <button
              className="dropdown-item"
              onClick={() => navigate("/userprofile")}
            >
              Profile
            </button>

            <button
              className="dropdown-item"
              onClick={handleLogout}
              disabled={loading}
            >
              {loading ? (
                <div className="d-flex align-items-center gap-2">
                  <Circles height="20" width="20" color="#FF650F" />
                  Logging out...
                </div>
              ) : (
                "Logout"
              )}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const Dashboard = () => {
  const [showSidebar, setShowSidebar] = useState(false);

  const [activeTab, setActiveTab] = useState("rfq");
  const [rfqData, setRfqData] = useState([]);
  const [rfqDatalength, setRfqDatalength] = useState("");
  const [inprogress, setInProgress] = useState("");
  const [won, setWon] = useState("");
  const [lost, setLost] = useState("");
  const [rfqreceiveddate, setRFQReceiveddate] = useState("");
  const [onhold, setOnHold] = useState("");
  const [poData, setPoData] = useState([]);
  const [clientname, setClientName] = useState("");
  const [staffname, setStaffName] = useState("");
  const [clientnamepo, setClientNamepo] = useState("");
  const [suppliername, setSupplierName] = useState("");
  const [poDatalength, setPoDatalength] = useState("");
  const [poDatalengthopen, setPoDatalengthopne] = useState("");
  const [poDatalengthclose, setPoDatalengthclose] = useState("");
  const [poREveiced, setPOreceived] = useState("");
  const [qoutationstaff, setQoutationStaff] = useState("");
  const [qoutationscliend, setQoutationscliend] = useState("");
  const [onTimePOChartData, setOnTimePOChartData] = useState([]);
  const [ccurrencyData, setCCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [rfqStatus, setRfqStatus] = useState([]);
  const [rfqbidStatus, setbidRfqStatus] = useState([]);
  const [latestUpdate, setLatestUpdate] = useState([]);
  const [showTableModal, setShowTableModal] = useState(false);
const [tableData, setTableData] = useState([]);
const [tableTitle, setTableTitle] = useState("");

const openTableModal = (title, data) => {
  setTableTitle(title);
  setTableData(data);
  setShowTableModal(true);
};

  function getStartOfWeek(date) {
    const d = new Date(date);
    const day = d.getDay();
    const diff = d.getDate() - day + (day === 0 ? -6 : 1); // Monday as start
    d.setHours(0, 0, 0, 0);
    return new Date(d.setDate(diff));
  }

  function getEndOfWeek(date) {
    const start = getStartOfWeek(date);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
    return end;
  }

  const allowedStatuses = [
    "RFQ Sent",
    "Supplier Quote received",
    "Quote submitted to Client",
    "Quote not Received From Supplier",
    "Under clarification",
  ];
  const allowedbidStatuses = ["Won", "Lost", "Onhold", "In-Progress"];

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/get-rfq-data`)
      .then((response) => {
        const Alllenght = response.data;
        setRfqDatalength(Alllenght.length);

        const thisWeekStart = getStartOfWeek(new Date());
        const thisWeekEnd = getEndOfWeek(new Date());

        const clientCounts = {};
        const staffCounts = {};
        const statusCounts = {};
        const bidstatusCounts = {};
        allowedStatuses.forEach((status) => {
          statusCounts[status] = 0;
        });
        allowedbidStatuses.forEach((status) => {
          bidstatusCounts[status] = 0;
        });

        Alllenght.forEach((rfq) => {
          console.log("rfq", rfq);

          const submitDate = rfq.quote_submit_date
            ? new Date(rfq.quote_submit_date)
            : null;
          const clientSubmitDate = rfq.quote_submit_client_date
            ? new Date(rfq.quote_submit_client_date)
            : null;

          if (allowedStatuses.includes(rfq.status)) {
            statusCounts[rfq.status]++;
          }
          if (allowedbidStatuses.includes(rfq.bid_status)) {
            bidstatusCounts[rfq.bid_status]++;
          }
          // Client chart: quote_submit_date grouped by client name
          if (
            submitDate &&
            submitDate >= thisWeekStart &&
            submitDate <= thisWeekEnd
          ) {
            if (rfq.client_name) {
              clientCounts[rfq.client_name] =
                (clientCounts[rfq.client_name] || 0) + 1;
            }
          }

          // Staff chart: quote_submit_client_date grouped by assigned staff
          if (
            clientSubmitDate &&
            clientSubmitDate >= thisWeekStart &&
            clientSubmitDate <= thisWeekEnd
          ) {
            if (rfq.assigned_staff) {
              staffCounts[rfq.assigned_staff] =
                (staffCounts[rfq.assigned_staff] || 0) + 1;
            }
          }
        });

        const clientDataPointsdate = Object.entries(clientCounts).map(
          ([label, y]) => ({ label, y }),
        );
        const staffDataPointsdate = Object.entries(staffCounts).map(
          ([label, y]) => ({ label, y }),
        );

        const statusData = allowedStatuses.map((status) => ({
          label: status,
          y: statusCounts[status],
        }));
        const bidstatusData = allowedbidStatuses.map((status) => ({
          label: status,
          y: bidstatusCounts[status],
        }));

        setQoutationscliend(staffDataPointsdate);
        setQoutationStaff(clientDataPointsdate);
        setRfqStatus(statusData);
        setbidRfqStatus(bidstatusData);
        // Capitalize each word (e.g., "abc corp" => "Abc Corp")
        const toTitleCase = (str) =>
          str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

        const countOccurrences = (array, key) => {
          const map = {};
          array.forEach((item) => {
            const value = item[key];
            if (value) {
              const normalized = value.trim().toLowerCase(); // normalize case
              map[normalized] = (map[normalized] || 0) + 1;
            }
          });
          return map;
        };

        // const getTop5DataPoints = (map) => {
        //   return Object.entries(map)
        //     .sort((a, b) => b[1] - a[1])
        //     .slice(0, 10)
        //     .map(([label, y]) => ({
        //       label: toTitleCase(label), // display nicely
        //       y,
        //     }));
        // };

        // Count and convert

        const getTop9PlusOther = (map) => {
          const sorted = Object.entries(map).sort((a, b) => b[1] - a[1]);

          const top9 = sorted.slice(0, 9);
          const others = sorted.slice(9);

          const otherCount = others.reduce((sum, [, count]) => sum + count, 0);

          const result = top9.map(([label, y]) => ({
            label: toTitleCase(label),
            y,
          }));

          if (otherCount > 0) {
            result.push({
              label: "Other",
              y: otherCount,
            });
          }

          return result; // total max = 10
        };

        const clientNameCounts = countOccurrences(Alllenght, "client_name");
        const assignedStaffCounts = countOccurrences(
          Alllenght,
          "assigned_staff",
        );

        const clientDataPoints = getTop9PlusOther(clientNameCounts);
        const staffDataPoints = getTop9PlusOther(assignedStaffCounts);

        // Set to state
        setClientName(clientDataPoints);
        setStaffName(staffDataPoints);

        const inprogress = Alllenght.filter(
          (item) => item.bid_status === "In-Progress",
        );
        const wonStatus = Alllenght.filter((item) => item.bid_status === "Won");
        const lostStatus = Alllenght.filter(
          (item) => item.bid_status === "Lost",
        );
        const ONholdStatus = Alllenght.filter(
          (item) => item.bid_status === "Onhold",
        );
        const currentMonth = new Date().getMonth(); // 0 = Jan, 11 = Dec
        const currentYear = new Date().getFullYear();

        const RFQReceivedThisMonth = Alllenght.filter((item) => {
          const rfqDate = new Date(item.rfq_date);
          return (
            rfqDate.getMonth() === currentMonth &&
            rfqDate.getFullYear() === currentYear
          );
        });

        setRFQReceiveddate(RFQReceivedThisMonth.length);
        setInProgress(inprogress.length);
        setWon(wonStatus.length);
        setLost(lostStatus.length);
        setOnHold(ONholdStatus.length);
        const reversedData = [...response.data].reverse().slice(0, 5);
        setRfqData(reversedData);
      })
      .catch((error) => {
        console.error("Error fetching RFQ data:", error);
      });
  }, []);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/api/get-po-data`)
      .then((response) => {
        const Alllenght = response.data;
        console.log("get-po-data", Alllenght);

        let onTimeCount = 0;

        Alllenght.forEach((po) => {
          if (po.latest_update === "Po Shipped") {
            const supplierDate = new Date(po.supplier_delivery_date);
            const clientDate = new Date(po.client_delivery_date);

            if (supplierDate <= clientDate) {
              onTimeCount++;
            }
          }
        });

        const chartData = [
          {
            label: "On Time",
            y: onTimeCount,
          },
        ];

        setOnTimePOChartData(chartData);

        setPoDatalength(Alllenght.length);

        const currencyCount = {};
        const clientCurrencyTotals = {};

        Alllenght.forEach((po) => {
          const currency = po.c_currency || "Unknown";
          const value = parseFloat(po.client_po_value) || 0;

          clientCurrencyTotals[currency] =
            (clientCurrencyTotals[currency] || 0) + value;
        });

        const supplierCurrencyTotals = {};

        Alllenght.forEach((po) => {
          const currency = po.currency || "Unknown";
          const value = parseFloat(po.supplier_po_value) || 0;

          supplierCurrencyTotals[currency] =
            (supplierCurrencyTotals[currency] || 0) + value;
        });

        const clientCurrencyPieData = Object.entries(clientCurrencyTotals).map(
          ([label, y]) => ({ label, y }),
        );

        setCCurrencyData(clientCurrencyPieData);

        const supplierCurrencyPieData = Object.entries(
          supplierCurrencyTotals,
        ).map(([label, y]) => ({ label, y }));

        setCurrencyData(supplierCurrencyPieData);

        const allowedLatestUpdates = [
          "Po Received From Client",
          "Po issued to supplier",
          "Po Under Progress",
          "Po Shipped",
          "Commercial Invoice Issue",
          "Payment Invoice Issue",
          "Payment Received",
          "Po Closed",
        ];

        const latestUpdateCounts = {};

        allowedLatestUpdates.forEach((status) => {
          latestUpdateCounts[status] = 0;
        });

        Alllenght.forEach((po) => {
          if (allowedLatestUpdates.includes(po.latest_update)) {
            latestUpdateCounts[po.latest_update]++;
          }
        });

        setLatestUpdate(latestUpdateCounts);

        Alllenght.forEach((po) => {
          const currency = po.currency || "Unknown";
          currencyCount[currency] = (currencyCount[currency] || 0) + 1;
        });

        // Convert to CanvasJS datapoints format
        // const total = Alllenght.length;
        // const pieData = Object.entries(currencyCount).map(([label, count]) => ({
        //   label,
        //   y: parseFloat(((count / total) * 100).toFixed(2)), // convert to percentage
        // }));

        // setCurrencyData(pieData);

        const countOccurrences = (array, key) => {
          const map = {};
          const displayNames = {}; // Store original casing

          array.forEach((item) => {
            const value = item[key];
            if (value) {
              const normalized = value.toLowerCase();
              map[normalized] = (map[normalized] || 0) + 1;

              // Keep the first encountered original name format
              if (!displayNames[normalized]) {
                displayNames[normalized] = value;
              }
            }
          });

          return { counts: map, displayNames };
        };

        // Convert object to sorted array of top 5 with correct display names
        // const getTop5DataPoints = (counts, displayNames) => {
        //   return Object.entries(counts)
        //     .sort((a, b) => b[1] - a[1])
        //     .slice(0, 5)
        //     .map(([normalized, y]) => ({
        //       label: displayNames[normalized],
        //       y,
        //     }));
        // };

        const getTop9PlusOtherDataPoints = (counts, displayNames) => {
          const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1]);

          const top9 = sorted.slice(0, 9);
          const others = sorted.slice(9);

          const otherTotal = others.reduce((sum, [, count]) => sum + count, 0);

          const result = top9.map(([normalized, y]) => ({
            label: displayNames[normalized],
            y,
          }));

          if (otherTotal > 0) {
            result.push({
              label: "Other",
              y: otherTotal,
            });
          }

          return result; // max 10 bars
        };

        // Get counts for client_name and supplier_name
        const { counts: clientNameCounts, displayNames: clientDisplayNames } =
          countOccurrences(Alllenght, "client_name");

        const { counts: supplierCounts, displayNames: supplierDisplayNames } =
          countOccurrences(Alllenght, "supplier_name");

        // Prepare dynamic data points
        const clientDataPoints = getTop9PlusOtherDataPoints(
          clientNameCounts,
          clientDisplayNames,
        );
        const supplierDataPoints = getTop9PlusOtherDataPoints(
          supplierCounts,
          supplierDisplayNames,
        );

        // Set state
        setClientNamepo(clientDataPoints);
        setSupplierName(supplierDataPoints);

        const openStatus = Alllenght.filter(
          (item) => item.latest_update === "Po Closed",
        );

        // All items where latest_update is NOT "PO Closed"
        const closeStatus = Alllenght.filter(
          (item) => item.latest_update !== "Po Closed",
        );

        // Set lengths
        setPoDatalengthopne(closeStatus.length);
        setPoDatalengthclose(openStatus.length);

        const currentMonth = new Date().getMonth(); // 0 = Jan, 11 = Dec
        const currentYear = new Date().getFullYear();

        const POReceivedThisMonth = Alllenght.filter((item) => {
          const rfqDate = new Date(item.client_po_date);
          return (
            rfqDate.getMonth() === currentMonth &&
            rfqDate.getFullYear() === currentYear
          );
        });
        setPOreceived(POReceivedThisMonth.length);
        const reversedData = [...response.data].reverse().slice(0, 5);

        setPoData(reversedData);
      })
      .catch((error) => {
        console.error("Error fetching PO data:", error);
      });
  }, []);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar Column */}
          <div className="custom-2-5">
            {activeTab === "rfq" && <SidebarRFQ />}
            {activeTab === "po" && <Sidebarpo />}
          </div>
          {activeTab === "rfq" && (
            <>
              <div className="custom-9-5 dashboardsclooer p-4">
                <TopBar activeTab={activeTab} setActiveTab={setActiveTab} />

                <div className="row mt-3 p-1">
                  <div className="col-lg-3 p2">
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">Total RFQs Received</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {rfqDatalength}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div className="col-lg-3 p2">
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">RFQs In Progress</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">{inprogress}</div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon1}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div className="col-lg-3 p2">
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">
                            RFQs Received This Month
                          </h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {rfqreceiveddate}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon2}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div className="col-lg-3 p2 ">
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">RFQ Won</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">{won}</div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon4}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row">
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6 p2">
                        <div
                          style={{
                            width: "100%",
                            height: 380,
                            backgroundColor: "white",
                            borderRadius: "16px",
                            padding: "20px",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <h3 className="cardhanding header-flex">
                          <span>RFQ Sent From Team</span>

                          <button
                            className="btn btn-sm btn-orange"
                            onClick={() =>
                              openTableModal("RFQ Sent From Team", staffname)
                            }
                          >
                            View
                          </button>
                        </h3>

                          {Array.isArray(staffname) && staffname.length > 0 && (
                            <ResponsiveContainer width="100%" height="80%">
                              <LineChart data={staffname}>
                                <defs>
                                  <linearGradient
                                    id="colorRFQ"
                                    x1="0"
                                    y1="0"
                                    x2="0"
                                    y2="1"
                                  >
                                    <stop
                                      offset="0%"
                                      stopColor="#FF6B00"
                                      stopOpacity={0.3}
                                    />
                                    <stop
                                      offset="100%"
                                      stopColor="#FF6B00"
                                      stopOpacity={0}
                                    />
                                  </linearGradient>
                                  <linearGradient
                                    id="colorQuote"
                                    x1="0"
                                    y1="0"
                                    x2="0"
                                    y2="1"
                                  >
                                    <stop
                                      offset="0%"
                                      stopColor="#00BFFF"
                                      stopOpacity={0.3}
                                    />
                                    <stop
                                      offset="100%"
                                      stopColor="#00BFFF"
                                      stopOpacity={0}
                                    />
                                  </linearGradient>
                                </defs>

                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="label" />
                                <YAxis
                                  tickFormatter={(tick) => `${tick}%`}
                                  domain={[0, 70]}
                                />
                                <Tooltip formatter={(value) => `${value}%`} />

                                {/* Area Fills Below Lines */}
                                <Area
                                  type="monotone"
                                  dataKey="y"
                                  stroke="none"
                                  fill="url(#colorRFQ)"
                                />
                                <Area
                                  type="monotone"
                                  dataKey="x"
                                  stroke="none"
                                  fill="url(#colorQuote)"
                                />

                                {/* Lines on top */}
                                <Line
                                  type="monotone"
                                  dataKey="y"
                                  stroke="#FF6B00"
                                  strokeWidth={2.5}
                                  dot={false}
                                />
                                <Line
                                  type="monotone"
                                  dataKey="x"
                                  stroke="#00BFFF"
                                  strokeWidth={2.5}
                                  dot={false}
                                />
                              </LineChart>
                            </ResponsiveContainer>
                          )}
                        </div>
                        {/* <div className="graphcss">
                          <CanvasJSChart
                            options={options}
                            containerProps={{
                              style: { height: "200px", width: "100%" },
                            }}
                          />
                        </div> */}
                      </div>
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart data2={clientname} openTableModal={openTableModal} 
 />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 p1">
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">RFQ Lost</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">{lost}</div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon5}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listrfq" className="link-card">
                      <div className="card cardcss mt-3 mobilecss">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding"> RFQ Clarification</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">{onhold}</div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon3}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart4 data2={qoutationscliend}  openTableModal={openTableModal}/>
                      </div>
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart5 data2={qoutationstaff}  openTableModal={openTableModal}/>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart6 data2={rfqStatus}  openTableModal={openTableModal}/>
                      </div>
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart7 data2={rfqbidStatus} openTableModal={openTableModal} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {activeTab === "po" && (
            <>
              <div className="custom-9-5 dashboardsclooer p-4">
                <TopBar activeTab={activeTab} setActiveTab={setActiveTab} />
                <div className="row mt-3 p-1">
                  <div className="col-lg-3 p2 ">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">
                            Total PO Receied This Month
                          </h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">{poREveiced}</div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>

                  <div className="col-lg-3 p2">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">Open POs</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {poDatalengthopen}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon1}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-lg-3 p2">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">Completed Pos </h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {poDatalengthclose}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon2}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                  <div className="col-lg-3 p2 ">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">PO Shipped</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Po Shipped"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon3}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row ">
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6 p2">
                        <div
                          style={{
                            width: "100%",
                            height: 380,
                            backgroundColor: "white",
                            borderRadius: "16px",
                            padding: "20px",
                            fontFamily: "sans-serif",
                          }}
                        >
                          <h3 className="cardhanding header-flex">
                          <span>PO Received by Client</span>

                          <button
                            className="btn btn-sm btn-orange"
                            onClick={() =>
                              openTableModal("PO Received by Client", clientnamepo)
                            }
                          >
                            View
                          </button>
                        </h3>

                          {Array.isArray(clientnamepo) &&
                            clientnamepo.length > 0 && (
                              <ResponsiveContainer width="100%" height="80%">
                                <LineChart data={clientnamepo}>
                                  <defs>
                                    <linearGradient
                                      id="colorRFQ"
                                      x1="0"
                                      y1="0"
                                      x2="0"
                                      y2="1"
                                    >
                                      <stop
                                        offset="0%"
                                        stopColor="#FF6B00"
                                        stopOpacity={0.3}
                                      />
                                      <stop
                                        offset="100%"
                                        stopColor="#FF6B00"
                                        stopOpacity={0}
                                      />
                                    </linearGradient>
                                    <linearGradient
                                      id="colorQuote"
                                      x1="0"
                                      y1="0"
                                      x2="0"
                                      y2="1"
                                    >
                                      <stop
                                        offset="0%"
                                        stopColor="#00BFFF"
                                        stopOpacity={0.3}
                                      />
                                      <stop
                                        offset="100%"
                                        stopColor="#00BFFF"
                                        stopOpacity={0}
                                      />
                                    </linearGradient>
                                  </defs>

                                  <CartesianGrid strokeDasharray="3 3" />
                                  <XAxis dataKey="label" />
                                  <YAxis
                                    tickFormatter={(tick) => `${tick}%`}
                                    domain={[0, 70]}
                                  />
                                  <Tooltip formatter={(value) => `${value}%`} />

                                  {/* Area Fills Below Lines */}
                                  <Area
                                    type="monotone"
                                    dataKey="y"
                                    stroke="none"
                                    fill="url(#colorRFQ)"
                                  />
                                  <Area
                                    type="monotone"
                                    dataKey="x"
                                    stroke="none"
                                    fill="url(#colorQuote)"
                                  />

                                  {/* Lines on top */}
                                  <Line
                                    type="monotone"
                                    dataKey="y"
                                    stroke="#FF6B00"
                                    strokeWidth={2.5}
                                    dot={false}
                                  />
                                  <Line
                                    type="monotone"
                                    dataKey="x"
                                    stroke="#00BFFF"
                                    strokeWidth={2.5}
                                    dot={false}
                                  />
                                </LineChart>
                              </ResponsiveContainer>
                            )}
                        </div>
                      </div>
                      <div className="col-lg-6 p2">
                        <AveragePOValueChart1 data2={suppliername} openTableModal={openTableModal} />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-3 p1">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">
                            PO Received From Client
                          </h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Po Received From Client"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon4}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss mt-3">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding">PO Issued to Supplier</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Po issued to supplier"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon5}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="row mt-1">
                  <div className="col-lg-9">
                    <div className="row">
                      <div className="col-lg-6 p2">
                        {/* <CanvasJSChart options={options4} /> */}
                        <AveragePOValueChart2 data2={ccurrencyData} openTableModal={openTableModal} />
                      </div>
                      <div className="col-lg-6 p2">
                        {/* <CanvasJSChart options={options4} /> */}
                        <AveragePOValueChartSupplier data2={currencyData} openTableModal={openTableModal} />
                      </div>

                      <div className="col-lg-6 p2">
                        {/* <CanvasJSChart options={options5} /> */}
                        {/* <AveragePOValueChart3 data2={onTimePOChartData} /> */}
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 p1">
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss">
                        <div className="card-body numbercss">
                          <h5 className="cardhanding">PO Under Progress</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Po Under Progress"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon5}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss mt-3">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding">
                            Commercial Invoice Issue
                          </h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Commercial Invoice Issue"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon2}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss mt-3">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding">Payment Invoice Issue</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Payment Invoice Issue"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon5}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss mt-3">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding">Payment Received</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["Payment Received"]}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon3}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                    <Link to="/listpo" className="link-card">
                      <div className="card cardcss mobilecss mt-3">
                        <div className="card-body numbercss ">
                          <h5 className="cardhanding">PO Closed</h5>
                          <p className="card-text mt-4">
                            <div className="row d-flex align-items-center justify-content-between">
                              <div className="col-9 col-lg-9">
                                {latestUpdate["PO Closed"] || 0}
                              </div>
                              <div className="col-3 col-lg-3 d-flex justify-content-end">
                                <img
                                  src={icon4}
                                  style={{ marginRight: "20px" }}
                                  alt="icon"
                                />
                              </div>
                            </div>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      {showTableModal && (
  <div className="custom-modal-overlay">
    <div className="custom-modal">
      <div className="modal-header">
        <h5>{tableTitle}</h5>
        <button onClick={() => setShowTableModal(false)}>✖</button>
      </div>

      <div className="modal-body">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Name</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item, index) => (
              <tr key={index}>
                <td>{item.label}</td>
                <td>{item.y}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}
    </>
  );
};

export default Dashboard;

const colors = ["#6EE7B7", "#FDBA74", "#86EFAC", "#C4B5FD", "#F9A8D4"];

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0];
    return (
      <div className="bg-white rounded px-2 py-1 border border-gray-200 text-xs shadow">
        <p style={{ margin: 0, fontWeight: 600 }}>{label}</p>
        <p className="text-gray-800 font-medium">{name}</p>
        <p className="text-gray-500">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(value)}
        </p>
      </div>
    );
  }
  return null;
};

const AveragePOValueChart = ({ data2 ,openTableModal }) => {
  return (
    <div
      className="p2 p-4 "
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
      <h3 className="cardhanding header-flex">
  RFQ Received From Client
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal("RFQ Received From Client", data2)}
  >
    View
  </button>
</h3>
    
      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data2}>
            <CartesianGrid
              stroke="#E5E7EB"
              strokeDasharray="0"
              vertical={false}
            />
            <XAxis
              dataKey="label"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />
            <YAxis
              axisLine={{ stroke: "#E9E8EC", strokeWidth: 1 }}
              tickLine={false}
              tickFormatter={(tick) =>
                tick >= 1000000
                  ? `${tick / 1000000}M`
                  : tick >= 1000
                    ? `${tick / 1000}K`
                    : tick
              }
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />

            {/* ✅ Add this line at 1M (or any other threshold you want) */}
            <ReferenceLine
              y={1000000}
              stroke="#A78BFA"
              strokeDasharray="3 3"
              strokeWidth={1}
            />

            <Tooltip content={<CustomTooltip />} />
            <Bar dataKey="y" radius={[4, 4, 0, 0]}>
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const CustomTooltip1 = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const { name, value } = payload[0];
    return (
      <div className="bg-white rounded px-2 py-1 border border-gray-200 text-xs shadow">
        <p className="text-gray-800 font-medium">{label}</p>
        <p className="text-gray-800 font-medium">{name}</p>
        <p className="text-gray-500">
          {Intl.NumberFormat("en-US", {
            notation: "compact",
            maximumFractionDigits: 1,
          }).format(value)}
        </p>
      </div>
    );
  }
  return null;
};

const AveragePOValueChart1 = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
      <h3 className="cardhanding header-flex">
  PO Send to Supplier
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal("PO Send to Supplier", data2)}
  >
    View
  </button>
</h3>
      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data2}>
            <CartesianGrid
              stroke="#E5E7EB"
              strokeDasharray="0"
              vertical={false}
            />
            <XAxis
              dataKey="label"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />
            <YAxis
              axisLine={{ stroke: "#E9E8EC", strokeWidth: 1 }}
              tickLine={false}
              tickFormatter={(tick) =>
                tick >= 1000000
                  ? `${tick / 1000000}M`
                  : tick >= 1000
                    ? `${tick / 1000}K`
                    : tick
              }
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />

            {/* ✅ Add this line at 1M (or any other threshold you want) */}
            <ReferenceLine
              y={1000000}
              stroke="#A78BFA"
              strokeDasharray="3 3"
              strokeWidth={1}
            />

            <Tooltip content={<CustomTooltip1 />} />
            <Bar dataKey="y" radius={[4, 4, 0, 0]}>
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const AveragePOValueChartSupplier = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
     
         <h3 className="cardhanding header-flex">
  PO,s Supplier Value
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal(" PO,s Supplier Value", data2)}
  >
    View
  </button>
</h3>
      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={data2}>
            <CartesianGrid
              stroke="#E5E7EB"
              strokeDasharray="0"
              vertical={false}
            />
            <XAxis
              dataKey="label"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />
            <YAxis
              axisLine={{ stroke: "#E9E8EC", strokeWidth: 1 }}
              tickLine={false}
              tickFormatter={(tick) =>
                tick >= 1000000
                  ? `${tick / 1000000}M`
                  : tick >= 1000
                    ? `${tick / 1000}K`
                    : tick
              }
              tick={{ fontSize: 12, fill: "#6B7280" }}
            />

            {/* ✅ Add this line at 1M (or any other threshold you want) */}
            <ReferenceLine
              y={1000000}
              stroke="#A78BFA"
              strokeDasharray="3 3"
              strokeWidth={1}
            />

            <Tooltip content={<CustomTooltip1 />} />
            <Bar dataKey="y" radius={[4, 4, 0, 0]}>
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const AveragePOValueChart2 = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
      
         <h3 className="cardhanding header-flex">
   PO,s Client Value
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal(" PO,s Client Value", data2)}
  >
    View
  </button>
</h3>

      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data2}
              dataKey="y"
              nameKey="label"
              cx="50%"
              cy="50%"
              outerRadius={90}
              innerRadius={40}
              label
            >
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

// const AveragePOValueChart3 = ({ data2 }) => {
//   return (
//     <div
//       className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
//       style={{
//         width: "100%",
//         height: 380,
//         backgroundColor: "white",
//         borderRadius: "16px",
//         padding: "20px",
//         fontFamily: "sans-serif",
//       }}
//     >
//       <h3
//         className="cardhanding text-lg font-semibold mb-4"
//         style={{ marginBottom: "10px", fontWeight: 600 }}
//       >
//         POs ON Time
//       </h3>

//       {Array.isArray(data2) && data2.length > 0 && (
//         <ResponsiveContainer width="100%" height={300}>
//           <PieChart>
//             <Pie
//               data={data2}
//               dataKey="y"
//               nameKey="label"
//               cx="50%"
//               cy="50%"
//               outerRadius={90}
//               innerRadius={40}
//               label
//             >
//               {data2.map((entry, index) => (
//                 <Cell
//                   key={`cell-${index}`}
//                   fill={colors[index % colors.length]}
//                 />
//               ))}
//             </Pie>
//             <Tooltip />
//             <Legend
//               layout="horizontal"
//               verticalAlign="bottom"
//               align="center"
//               iconType="circle"
//             />
//           </PieChart>
//         </ResponsiveContainer>
//       )}
//     </div>
//   );
// };

const AveragePOValueChart4 = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
     
        <h3 className="cardhanding header-flex">
   Quotation Submitted by Staff this Week
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal(" Quotation Submitted by Staff this Week", data2)}
  >
    View
  </button>
</h3>

      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data2}
              dataKey="y"
              nameKey="label"
              cx="50%"
              cy="50%"
              outerRadius={90}
              innerRadius={40}
              label
            >
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const AveragePOValueChart5 = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
     
        <h3 className="cardhanding header-flex">
   Quotation Submitted to Clients this Week
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal(" Quotation Submitted to Clients this Week", data2)}
  >
    View
  </button>
</h3>

      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data2}
              dataKey="y"
              nameKey="label"
              cx="50%"
              cy="50%"
              outerRadius={90}
              innerRadius={40}
              label
            >
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};

const AveragePOValueChart6 = ({ data2,openTableModal }) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
     
        <h3 className="cardhanding header-flex">
    RFQ Status
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal("  RFQ Status", data2)}
  >
    View
  </button>
</h3>

      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data2}
              dataKey="y"
              nameKey="label"
              cx="50%"
              cy="50%"
              outerRadius={90}
              innerRadius={40}
              label
            >
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
const AveragePOValueChart7 = ({ data2 ,openTableModal}) => {
  return (
    <div
      className="rounded-2xl bg-[#F9FAFB] p-4 shadow-sm w-full max-w-md"
      style={{
        width: "100%",
        height: 380,
        backgroundColor: "white",
        borderRadius: "16px",
        padding: "20px",
        fontFamily: "sans-serif",
      }}
    >
     
        <h3 className="cardhanding header-flex">
    RFQ Bid Status
  <button
    className="btn btn-sm btn-orange float-end"
    onClick={() => openTableModal("  RFQ  Bid Status", data2)}
  >
    View
  </button>
</h3>

      {Array.isArray(data2) && data2.length > 0 && (
        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={data2}
              dataKey="y"
              nameKey="label"
              cx="50%"
              cy="50%"
              outerRadius={90}
              innerRadius={40}
              label
            >
              {data2.map((entry, index) => (
                <Cell
                  key={`cell-${index}`}
                  fill={colors[index % colors.length]}
                />
              ))}
            </Pie>
            <Tooltip />
            <Legend
              layout="horizontal"
              verticalAlign="bottom"
              align="center"
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
